// TODO: update splide version
import Splide from '@splidejs/splide';

import {
  _isMobile,
  _isOnPage,
  _isOnScreen,
  _on,
  _once,
  _scrollTo,
  initSplideWidget,
} from '../utils';

import initTabs from './js/tabs';

import '@splidejs/splide/dist/css/splide.min.css';
import './index.scss';
import './css/design-system.css';
import './css/redesign.css';
import './css/landing.css';
import './css/landing-v2.css';
import './css/table.css';
import './css/our-team.css';
import './css/hiw-block.css';

window.dataLayer = window.dataLayer || [];
const MOBILE_FLOW_BREAKPOINT = 431;

_isOnScreen('.hiw__beacon', () => document.querySelector('.hiw__list').classList.add('animate'));

_on('click', 'js--order', () => {
  window.bbSetOrder({ threshold: 400 });
});

_on('click', 'js--request-writer-form', ({ target }) => {
  window.bbSetOrder({ domain: '/', writer_req_slug: target.dataset.slug, threshold: 240 });
});

_on('click', 'js--flow-order', () => {
  if (window.innerWidth > MOBILE_FLOW_BREAKPOINT) {
    window.bbSetOrder({ threshold: 350 });
  } else {
    window.location.href = '/registration.html';
  }
});

['.tabs--reviews'].forEach(tab => initTabs(tab));

_isOnPage(
  '.splide--hiw',
  _once(() => {
    const splide = new Splide('.splide--hiw', {
      perPage: 1,
      arrows: true,
      pagination: true,
      fixedHeight: 340,
      breakpoints: {
        1024: {
          fixedHeight: false,
        },
      },
    });

    splide.on('pagination:mounted', function (data) {
      data.list.classList.add('splide__pagination--hiw');
      data.items.forEach(function (item) {
        item.button.textContent = `Step ${item.page + 1}`;
      });
    });
    splide.mount();
  }),
);

_isOnPage(
  '.splide--hiw-block',
  _once(() => {
    const splide = new Splide('.splide--hiw-block', {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: 5000,
      width: 558,
      pauseOnFocus: false,
      pauseOnHover: false,
      perPage: 1,
      pagination: false,
      fixedHeight: 493,
      resetProgress: true,
      breakpoints: {
        320: {
          width: 300,
          arrows: true,
          fixedHeight: false,
        },
        375: {
          width: 360,
          arrows: true,
          fixedHeight: false,
        },
        425: {
          width: 410,
          arrows: true,
          fixedHeight: false,
        },
        558: {
          width: 545,
          arrows: true,
          fixedHeight: false,
        },
        1024: {
          arrows: true,
          fixedHeight: false,
          width: 558,
        },
        4096: {
          arrows: false,
          width: 558,
        },
      },
    });
    const desktopSteps = document.querySelectorAll('.hiw__step');
    // side desktop step buttons click
    desktopSteps.forEach(function (button) {
      button.addEventListener('click', function () {
        var slideIndex = button.getAttribute('data-slide');
        splide.go(slideIndex);
      });
    });

    splide.on('active', function ({ index }) {
      desktopSteps.forEach((step, stepIndex) => {
        step.classList.toggle('active', index === stepIndex);
      });
    });

    splide.mount();

    if (_isMobile()) {
      const maxStepHeight = [...desktopSteps].reduce((max, el) => {
        return Math.max(max, el.clientHeight);
      }, 0);

      const stepsContainer = document.querySelector('.hiw__steps');
      stepsContainer.style.minHeight = `${maxStepHeight}px`;
    } else {
      const stepDescriptions = document.querySelectorAll('.hiw__step-description');
      const maxDescriptionHeight = [...stepDescriptions].reduce((max, el) => {
        return Math.max(max, el.clientHeight);
      }, 0);

      stepDescriptions.forEach(el => {
        el.style.height = `${maxDescriptionHeight}px`;
      });
    }
  }),
);

initSplideWidget('splide--reviews', {
  breakpoints: {
    600: {
      perPage: 1,
      fixedWidth: 312,
    },
    1024: {
      perPage: 2,
    },
    4096: {
      perPage: 3,
    },
  },
});
initSplideWidget('splide--sitejabber', {
  breakpoints: {
    600: {
      perPage: 1,
      fixedWidth: 312,
    },
    1024: {
      perPage: 2,
    },
    4096: {
      perPage: 3,
    },
  },
});
initSplideWidget('splide--reviewsIO', {
  breakpoints: {
    600: {
      perPage: 1,
      fixedWidth: 312,
    },
    1024: {
      perPage: 2,
    },
    4096: {
      perPage: 3,
    },
  },
});
initSplideWidget('splide--best-writers');
initSplideWidget('splide--writing-app');
initSplideWidget('splide--essay-app', { arrows: false });

_on('click', 'js--seo-space', e => {
  if (document.querySelector('.seo-space_hidden')) {
    document
      .querySelectorAll('.seo-space_hidden')
      .forEach(item => item.classList.add('seo-space_visible'));
    e.target.remove();
  }
});

_on('click', 'js--to-reviews', () => {
  _scrollTo('.section--reviews', { threshold: 20 });
});
